<template>

<app-view-list-field :is-sticky="isSticky" :is-demoted="isDemoted" :field="field" :filter="filter">

    <span>{{ value }}</span>

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isDemoted'],

	computed: {

		value: function() {

			return (this.item.collection && this.item.collection.location) ? this.item.collection.location : '-'

		}

	}

}

</script>
